import React, {useEffect, useState} from "react";
import {useRecoilState, useRecoilValue} from "recoil";

import './BatchCloseModal.scss'

import {Modal} from "@carbon/react";
import {forceCloseAlarmsModalIdsState, forceCloseAlarmsModalOpenState,} from "../../../state/alerts_table";
import {grpcAlarmServiceSelector} from "../../../state/grpc";
import {ADD, useToastContext} from "../../Toast";
import PropTypes from "prop-types";

const BatchCloseModal = (props) => {
  const {toastDispatch} = useToastContext();
  const [forceCloseAlarmsModalOpen, setForceCloseAlarmsModalOpen] = useRecoilState(forceCloseAlarmsModalOpenState)
  const forceCloseAlarmsModalIds = useRecoilValue(forceCloseAlarmsModalIdsState)
  const alarmsService = useRecoilValue(grpcAlarmServiceSelector)
  const single = forceCloseAlarmsModalIds.length === 1
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(false)
  }, [forceCloseAlarmsModalOpen])

  const handleBatchClose = () => {
    const req = new proto.api.CloseAlarmsRequest()
    req.setAlarmsidsList(forceCloseAlarmsModalIds)
    alarmsService.closeAlarms(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione fallita",
            content: "Non è stato possibile completare l'operazione",
            kind: "error",
            caption: err.message
          }
        })
      } else {
        const closed = resp.toObject().closed
        if (closed < forceCloseAlarmsModalIds.length) {
          const delta = forceCloseAlarmsModalIds.length - closed
          toastDispatch({
            type: ADD,
            payload: {
              title: "Operazione parzialmente fallita",
              content: "Non è stato possibile completare l'operazione per alcuni record",
              kind: "warning",
              caption: "Non è stato possibile chiudere " + delta + " dei " + forceCloseAlarmsModalIds.length + " allarmi richiesti. Si prega di verificare manualmente lo stato"
            }
          })
        } else {
          toastDispatch({
            type: ADD,
            payload: {
              title: "Operazione completata con successo",
              content: closed + " allarmi chiusi con successo",
              kind: "success"
            }
          })
        }
        props.onAlarmsClosed()
      }
      setLoading(false)
    })
  }

  return (
    <Modal
      modalHeading={"Chiusura forzata allarm" + (single ? "e" : "i")}
      modalLabel={single ? "Azione singola" : "Azione di gruppo"}
      open={forceCloseAlarmsModalOpen}
      danger
      primaryButtonText={loading ? "Chiusura allarmi in corso.." : "Procedi"}
      secondaryButtonText="Annulla"
      onRequestClose={() => setForceCloseAlarmsModalOpen(false)}
      onRequestSubmit={handleBatchClose}>
      <p style={{marginBottom: '1rem'}}>
        Attenzione, questa è un'operazione irreversibile. Assicurati di voler davvero chiudere gli allarmi selezionati
        prima di procedere.
        Una volta avviata la procedura non si può annullare, attendi quindi mentre gli allarmi selezionati vengono
        chiusi come richiesto.
        Questa procedura potrebbe richiedere un po' di tempo.
      </p>
      <div style={{marginBottom: '1rem'}}>
        <span>Numero di allarmi da chiudere: </span><span
        style={{fontWeight: "bold"}}>{forceCloseAlarmsModalIds.length}</span>
      </div>
    </Modal>
  )
}

BatchCloseModal.propTypes = {
  onAlarmsClosed: PropTypes.func.isRequired,
}

export default BatchCloseModal